import React from 'react'
import { Card, Col, Row, Typography } from 'antd'
import IntlMessages from 'util/IntlMessages'

const { Paragraph } = Typography

const General = () => {
	return (
		<Row>
			<Col xl={24} lg={24} md={24} sm={24} xs={24}>
				<Row gutter={32} type="flex">
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%', height: '90%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='general.left.paragraph.1' />
								</Paragraph>
								<Paragraph>
									<IntlMessages id='general.left.paragraph.2' />
								</Paragraph>
							</Typography>
						</Card>
					</Col>
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%', height: '90%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='general.right.paragraph.1' />
								</Paragraph>
								<Paragraph>
									<IntlMessages id='general.right.paragraph.2' />
								</Paragraph>
								<Paragraph>
									<IntlMessages id='general.right.paragraph.3' />
								</Paragraph>
							</Typography>
						</Card>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default General
